<template>
  <!--优惠券-->
  <div style="width: 100%" class="content bg-white">
    <div class="flex-space-between font-normal margin-tb-10 coupon-img padding-rl-5 margin-rl-10 padding-tb-10">
    </div>
  </div>
</template>

<script>
export default {
    name: "magCpns"
}
</script>

<style scoped>
  .coupon-img {
    height: 100px;
    background-image: url(http://images.weserv.nl/?url=http://zone-yingerfashion.oss-cn-shenzhen.aliyuncs.com/storage/images/system-image/91352921fa0784c82c81bde56d785e7a.png);
    background-size: auto 100%;
    background-repeat: no-repeat;
  }
</style>